function composeEventHandlers(originalEventHandler, ourEventHandler, { checkForDefaultPrevented =true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 ? void 0 : originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
        return undefined;
    };
}
export default composeEventHandlers;
